export default "__VITE_ASSET__bIzgO_v7__"